module.exports = __webpack_public_path__ + "img/P35920580EG.e6b81b27.jpg";